{
	"selectPeriod": "Seleccionar un periodo",
	"periodSelected": "Periodo seleccionado",
	"reset": "Resetear",
	"apply": "Aplicar",
	"ariaLabels": {
		"periodSelection": "Seleccionar un periodo",
		"periodSelectionOptions": "Opciones de selección de periodo",
		"periodSelectionDialog": "Selección de periodo",
		"dateRangeSelection": "Selección de rango de fechas",
		"dateRangeSelectionActions": "Acciones de selección de rango de fechas",
		"resetDateRange": "Resetear selección de rango de fechas",
		"applyDateRange": "Aplicar selección de rango de fechas"
	}
}
